import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const ItemsDetailsRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ItemDetails = styled(Box)`
  display: inline-block;
  width: 33.3%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  padding: 10px;
  font: normal normal ${(props) => (props.bold ? 'bold' : '400')} 1rem
    ${(props) => props.fontFamily ?? 'Source Sans Pro'};
`;
